import React from 'react';
import { Grid, Row, Col } from 'react-bootstrap';
import { SafecosmeticDashboardContainer } from './SafecosmeticDashboard2';
// import PhraseListContainer from './ErrorList/_PhraseListContainer';

const SafecosmeticDashboard = props =>
  (<Grid fluid>
    <Row>
      <Col md={12}>
        <SafecosmeticDashboardContainer {...props} />
      </Col>
    </Row>
  </Grid>);

export default SafecosmeticDashboard;
